import React from 'react'

type Props = {
  children: React.ReactNode
}

type State = {
  hasError: boolean
}

export class ChunkErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    // Check if it's a chunk loading error
    if (
      error.name === 'ChunkLoadError' ||
      error.message?.includes('Loading chunk') ||
      error.message?.includes('Loading CSS chunk') ||
      error.message?.includes('Failed to fetch dynamically imported module')
    ) {
      const key = 'chunk_error_reload'
      const hasReloaded = sessionStorage.getItem(key)
      if (!hasReloaded) {
        sessionStorage.setItem(key, '1')
        window.location.reload()
        return { hasError: true }
      }
      sessionStorage.removeItem(key)
    }
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Application error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            gap: 16,
            fontFamily: 'sans-serif',
          }}
        >
          <h2>Something went wrong</h2>
          <p style={{ color: '#666' }}>
            The application may have been updated. Please reload the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 24px',
              fontSize: 14,
              cursor: 'pointer',
              borderRadius: 6,
              border: '1px solid #d9d9d9',
              background: '#3b82f6',
              color: '#fff',
            }}
          >
            Reload page
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
